import actions from '@/store/modules/ui/actions';
import mutations from '@/store/modules/ui/mutations';

const namespaced = true;

// Locally defined modules
const dropdowns = { namespaced };

const moduleUI = {
  namespaced: true,

  state: {},
  getters: {},
  actions: {
    ...actions,
  },
  mutations: {
    ...mutations,
  },
  modules: {
    dropdowns,
  },
};

export default moduleUI;
